import React, { useEffect, useState, useContext } from "react";
import {
  Field,
  Checkbox,
  Combobox,
  Option,
  Divider,
  Card,
  CardHeader,
  Caption1Strong,
  CardPreview,
} from "@fluentui/react-components";
import { SettingsRegular } from "@fluentui/react-icons";
import { AppContext } from "./context/AppContext";
import { SheetOptionService } from "../../service/SheetOptionService";
import { getProfileFromStorage } from "../../utils/profilepreferencesave";
import { getStringFromStorage } from "../../utils/storagehelper";
import { ProfileSettings } from "../../types/app.storage.enums";
import SubHeader from "./SubHeader";
import Loader from "./Loader";
import { useSheetOptionStyles, useStackClassName } from "./style/sheetoptions.style";
import { getActiveSheetOptions, setActiveSheetOptions } from "../../utils/sheetoptions";
import { reCalculate } from "../../utils/officedocumenthelper";
import { isValidUser } from "../../utils/common";
import { useNavigate } from "react-router-dom";
const SheetOption = () => {
  const styles = useSheetOptionStyles();
  const context = useContext(AppContext);
  const [currencyNeutralList, SetCurrencyNeutralList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCurrencyNeutral, SetSelectedCurrencyNeutral] = useState([]);
  const [selectedCurrencyNeutralText, SetSelectedCurrencyNeutralText] = useState("");
  const [sheetoptions, setSheetOptions] = useState(null);
  const navigate = useNavigate();

  const initialize = async () => {
    const option = await getActiveSheetOptions();
    if (!option.CurrencyHedgeFlag || option.CurrencyHedgesetId === 0) {
      SetSelectedCurrencyNeutral([]);
      SetSelectedCurrencyNeutralText("");
    } else {
      getCurrencyHedgeText(option.CurrencyHedgesetId);
    }
    if (option) setSheetOptions(option);
  };

  const currencyNeutralChange = async (_e, data) => {
    //SetSelectedCurrencyNeutral(() => data.selectedOptions);
    getCurrencyHedgeText(data.selectedOptions);
    setSheetOptions({ ...sheetoptions, CurrencyHedgesetId: data.selectedOptions[0] });
    await setActiveSheetOptions({ ...sheetoptions, CurrencyHedgesetId: data.selectedOptions[0] });
    reCalculate();
  };

  const currencyNeutralCheckChange = async (e) => {
    if(isValidUser()){
      navigate("/home");
    } else {
    SetSelectedCurrencyNeutral(() => []);
    setSheetOptions({ ...sheetoptions, CurrencyHedgesetId: 0, CurrencyHedgeFlag: e.target.checked });
    await setActiveSheetOptions({ ...sheetoptions, CurrencyHedgesetId: 0, CurrencyHedgeFlag: e.target.checked });
    }
  };

  const checkBoxChange = async (e) => {
    if(isValidUser()){
      navigate("/home");
    }else {
    setSheetOptions({ ...sheetoptions, [e.target.name]: !sheetoptions[e.target.name] });
    await setActiveSheetOptions({ ...sheetoptions, [e.target.name]: !sheetoptions[e.target.name] });
    reCalculate();
    }
  };

  const handleSheetChanged = async (_e) => {
    console.log("sheetoption");
    initialize();
  };

  const getCurrencyHedge = (profileid) => {
    new SheetOptionService()
      .getCurrencyHedge(profileid)
      .then((result) => {
        SetCurrencyNeutralList(() => (Array.isArray(result) ? result : []));
      })
      .catch((error) => {
        console.log("Error: " + error);
        SetCurrencyNeutralList(() => []);
      })
      .finally(() => {
        setIsLoading(() => false);
      });
  };

  const getCurrencyHedgeText = (CurrencyHedgesetId) => {
    if (getStringFromStorage(ProfileSettings.ProfileId) && !context.selectedProfile) {
      getProfileFromStorage().then((profile) => {
        context.setSelectedProfile(profile);
        populateCurrencyHedgese(profile.profileID, CurrencyHedgesetId);
      });
    } else {
      populateCurrencyHedgese(context.selectedProfile.profileID, CurrencyHedgesetId);
    }
  };

  const populateCurrencyHedgese = (profileid, CurrencyHedgesetId) => {
    new SheetOptionService().getCurrencyHedge(profileid).then((result) => {
      const objIndex = result.find((obj) => obj.code == CurrencyHedgesetId);
      SetSelectedCurrencyNeutral([objIndex.code]);
      SetSelectedCurrencyNeutralText(objIndex.text);
    });
  };
  useEffect(() => {
    if(isValidUser()){
      navigate("/home");
      return;
    }else{
    Excel.run(async (context) => {
      const worksheets = context.workbook.worksheets;

      worksheets.onActivated.add(handleSheetChanged);
      await context.sync();
      return () => {
        worksheets.onActivated.remove(handleSheetChanged);
      };
    
    });

    if (getStringFromStorage(ProfileSettings.ProfileId) && !context.selectedProfile) {
      getProfileFromStorage().then((profile) => {
        context.setSelectedProfile(profile);
        getCurrencyHedge(profile.profileID);
      });
    } else {
      getCurrencyHedge(context.selectedProfile.profileID);
    }
  }
  }, []);

  useEffect(() => {
    initialize();
  }, [context.isSheetAddedOrRemoved]);

  return (
    <>
      <SubHeader title="Sheet Options" subtitle="Settings" icon={<SettingsRegular></SettingsRegular>}></SubHeader>
      <div className={styles.root}>
        <Card className={styles.card} appearance="subtle">
          <CardHeader
            header={<Caption1Strong>Note: This settings will be applicable for current sheet only</Caption1Strong>}
          ></CardHeader>
          <CardPreview className={styles.cardPreview}>
            <div className={useStackClassName()}>
              <Field className={styles.inputcheckbox}>
                <Checkbox
                  name="performHoldingLookThrough"
                  label="Perform Holdings Look-Through"
                  checked={sheetoptions && sheetoptions.performHoldingLookThrough}
                  onChange={checkBoxChange}
                />
              </Field>
              <Divider className={styles.dividerPT}></Divider>
              <Field className={styles.inputcheckbox}>
                <Checkbox
                  name="excludeFrozenAssets"
                  label="Exclude Frozen Assets"
                  checked={sheetoptions && sheetoptions.excludeFrozenAssets}
                  onChange={checkBoxChange}
                />
              </Field>
              <Divider className={styles.dividerPT}></Divider>
              <Field className={styles.inputcheckbox}>
                <Checkbox
                  label="Use Currency Neutral"
                  onChange={currencyNeutralCheckChange}
                  checked={sheetoptions && sheetoptions.CurrencyHedgeFlag}
                />
              </Field>
              <Field className={styles.input}>
                <Combobox
                  defaultValue=""
                  disabled={!sheetoptions || !sheetoptions.CurrencyHedgeFlag}
                  onOptionSelect={currencyNeutralChange}
                  selectedOptions={selectedCurrencyNeutral}
                  placeholder={selectedCurrencyNeutral[0]}
                  value={selectedCurrencyNeutralText}
                >
                  {currencyNeutralList.map((item) => {
                    return (
                      <Option key={item.code} value={item.code}>
                        {item.text + " [" + item.baseCurrency + "]"}
                      </Option>
                    );
                  })}
                </Combobox>
              </Field>
              <Divider className={styles.dividerPT}></Divider>
              <Field className={styles.inputcheckbox}>
                <Checkbox
                  name="useReceivedDateFitler"
                  label="Use Received Date Filter"
                  checked={sheetoptions && sheetoptions.useReceivedDateFitler}
                  onChange={checkBoxChange}
                />
              </Field>
              <Divider className={styles.dividerPT}></Divider>
            </div>
          </CardPreview>
        </Card>
      </div>
      {isLoading && <Loader></Loader>}
    </>
  );
};

export default SheetOption;
